<div class="user-management-container">
  <h1>{{ 'user_management.title' | translate }}</h1>
  <p>{{ 'user_management.subtitle' | translate }}</p>

  <!-- 錯誤訊息顯示 -->
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- 載入中指示器 -->
  <div *ngIf="isLoading" class="loading-spinner">
    <div class="spinner"></div>
    <p>{{ 'user_management.loading' | translate }}</p>
  </div>

  <!-- 主要內容區域：左右分欄 -->
  <div *ngIf="!isLoading" class="main-content">

    <!-- 左側：組織管理 -->
    <div class="organization-panel" [class.collapsed]="isOrgPanelCollapsed">
      <div class="panel-header">
        <h2 *ngIf="!isOrgPanelCollapsed">{{ 'user_management.organization.title' | translate }}</h2>
        <div class="panel-controls">
          <button class="btn btn-collapse" (click)="toggleOrgPanel()" [title]="isOrgPanelCollapsed ? ('user_management.organization.expand' | translate) : ('user_management.organization.collapse' | translate)">
            <i class="fas" [class.fa-chevron-left]="!isOrgPanelCollapsed" [class.fa-chevron-right]="isOrgPanelCollapsed"></i>
          </button>
          <button *ngIf="!isOrgPanelCollapsed" class="btn btn-settings" (click)="openOrgSettingsModal()" [title]="'user_management.organization.settings' | translate">
            <i class="fas fa-cog"></i>
          </button>
        </div>
      </div>

      <div class="organization-tree" *ngIf="organizationData && !isOrgPanelCollapsed">
        <app-organization-tree-node
          [node]="organizationData"
          [selectedDepartment]="selectedDepartment"
          [isRootNode]="true"
          (nodeSelected)="selectDepartment($event)"
          (nodeToggled)="toggleNode($event)">
        </app-organization-tree-node>
      </div>
    </div>

    <!-- 右側：用戶列表 -->
    <div class="user-table-container">
      <div class="table-header">
        <div class="header-title">
          <h2>{{ 'user_management.user_list.title' | translate }}</h2>
          <span *ngIf="selectedDepartment" class="department-filter-info">
            {{ selectedDepartment.name }}
          </span>
          <span class="user-count-info">{{ 'user_management.user_list.total_users' | translate:{ count: filteredUsers.length } }}</span>
        </div>
        <div class="header-actions">
          <button *ngIf="selectedDepartment" class="btn btn-secondary" (click)="resetUserFilter()">
            <i class="fas fa-times"></i> {{ 'user_management.user_list.clear_filter' | translate }}
          </button>
          <!-- 當有部門選中且有用戶被選中時，顯示移除按鈕 -->
          <button *ngIf="selectedDepartment && selectedDepartment.type === 'department' && getSelectedUsersCount() > 0"
                  class="btn btn-danger" (click)="removeSelectedUsersFromDepartment()">
            <i class="fas fa-user-minus"></i> {{ 'user_management.user_list.remove_selected' | translate }} ({{ getSelectedUsersCount() }})
          </button>
          <button *ngIf="selectedDepartment && selectedDepartment.type === 'department'"
                  class="btn btn-primary" (click)="openDepartmentMemberModal()">
            <i class="fas fa-user-plus"></i> {{ 'user_management.user_list.add_department_member' | translate }}
          </button>
          <button class="btn btn-primary" (click)="openUserModal()">+ {{ 'user_management.user_list.add_user' | translate }}</button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="user-table">
          <thead>
            <tr>
              <!-- 當選擇了部門時，顯示複選框欄位 -->
              <th *ngIf="selectedDepartment && selectedDepartment.type === 'department'" width="50">
                <input type="checkbox"
                       [checked]="isSelectAllChecked"
                       (change)="onSelectAllChange($event)"
                       [disabled]="filteredUsers.length === 0"
                       class="form-check-input">
              </th>
              <th>{{ 'user_management.table.index' | translate }}</th>
              <th>{{ 'user_management.table.username' | translate }}</th>
              <th>{{ 'user_management.table.full_name' | translate }}</th>
              <th>{{ 'user_management.table.email' | translate }}</th>
              <th>{{ 'user_management.table.organization_unit' | translate }}</th>
              <th>{{ 'user_management.table.role' | translate }}</th>
              <th>{{ 'user_management.table.available_assistants' | translate }}</th>
              <th>{{ 'user_management.table.status' | translate }}</th>
              <th>{{ 'user_management.table.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of filteredUsers; let i = index">
              <!-- 當選擇了部門時，顯示複選框 -->
              <td *ngIf="selectedDepartment && selectedDepartment.type === 'department'">
                <input type="checkbox"
                       [checked]="isUserSelected(user.id)"
                       (change)="onUserCheckboxChange(user.id, $event)"
                       class="form-check-input user-checkbox">
              </td>
              <td>{{ i + 1 }}</td>
              <td>{{ user.username }}</td>
              <td>{{ user.fullName }}</td>
              <td>{{ user.email }}</td>
              <td>
                <div class="organization-unit-tags">
                  <span *ngFor="let tag of getOrganizationUnitTags(user)"
                        class="org-unit-tag"
                        [ngClass]="{'org-unit-unassigned': tag === ('user_management.table.unassigned' | translate)}">
                    {{ tag }}
                  </span>
                </div>
              </td>
              <td>
                <span class="role-badge" [ngClass]="getUserRoleClass(user)">
                  {{ getUserRoleDisplay(user) }}
                </span>
              </td>
              <td>
                <span class="assistant-count" [ngClass]="getAssistantCountClass(user)">
                  {{ getAssistantCountDisplay(user) }}
                </span>
              </td>
              <td>
                <span [ngClass]="user.enabled ? 'status-enabled' : 'status-disabled'">
                  {{ user.enabled ? ('user_management.table.enabled' | translate) : ('user_management.table.disabled' | translate) }}
                </span>
              </td>
              <td class="actions">
                <button class="btn btn-sm btn-edit" (click)="editUser(user)">{{ 'user_management.table.edit' | translate }}</button>
                <button class="btn btn-sm btn-delete" (click)="deleteUser(user)">{{ 'user_management.table.delete' | translate }}</button>
              </td>
            </tr>
            <tr *ngIf="filteredUsers.length === 0">
              <td [attr.colspan]="selectedDepartment && selectedDepartment.type === 'department' ? 10 : 9"
                  class="no-data">{{ 'user_management.user_list.no_data' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- 用戶表單彈出視窗 -->
  <div class="modal-backdrop" [class.show]="showModal" (click)="closeUserModal()"></div>
  <div class="modal-dialog" [class.show]="showModal">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ isEditing ? ('user_management.form.edit_user' | translate) : ('user_management.form.add_user' | translate) }}</h3>
        <button type="button" class="close-btn" (click)="closeUserModal()">&times;</button>
      </div>
      <div class="modal-body">
        <form #userForm="ngForm">
          <!-- 基本資料 -->
          <div class="form-row">
            <div class="form-group">
              <label for="username">{{ 'user_management.form.username' | translate }} *</label>
              <input type="text" id="username" name="username" [(ngModel)]="userData.username"
                #username="ngModel" [placeholder]="'user_management.form.username_placeholder' | translate" class="form-control" required minlength="3">
              <div *ngIf="username.invalid && (username.dirty || username.touched)" class="error-text">
                <span *ngIf="username.errors?.['required']">{{ 'user_management.form.username_required' | translate }}</span>
                <span *ngIf="username.errors?.['minlength']">{{ 'user_management.form.username_minlength' | translate }}</span>
              </div>
            </div>

            <div class="form-group">
              <label for="password">{{ 'user_management.form.password' | translate }} {{ isEditing ? ('user_management.form.password_optional' | translate) : '*' }}</label>
              <input type="password" id="password" name="password" [(ngModel)]="userData.password"
                #password="ngModel" [placeholder]="'user_management.form.password_placeholder' | translate" class="form-control"
                [required]="!isEditing" minlength="6">
              <div *ngIf="!isEditing && password.invalid && (password.dirty || password.touched)" class="error-text">
                <span *ngIf="password.errors?.['required']">{{ 'user_management.form.password_required' | translate }}</span>
                <span *ngIf="password.errors?.['minlength']">{{ 'user_management.form.password_minlength' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="fullName">{{ 'user_management.form.full_name' | translate }}</label>
              <input type="text" id="fullName" name="fullName" [(ngModel)]="userData.fullName"
                [placeholder]="'user_management.form.full_name_placeholder' | translate" class="form-control">
            </div>

            <div class="form-group">
              <label for="email">{{ 'user_management.form.email' | translate }}</label>
              <input type="email" id="email" name="email" [(ngModel)]="userData.email"
                #email="ngModel" [placeholder]="'user_management.form.email_placeholder' | translate" class="form-control" email>
              <div *ngIf="email.invalid && (email.dirty || email.touched)" class="error-text">
                <span *ngIf="email.errors?.['email']">{{ 'user_management.form.email_invalid' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="form-row">
            <!-- 部門欄位已隱藏 - 使用新的組織架構管理方式 -->
            <!-- <div class="form-group">
              <label for="department">{{ 'user_management.form.department' | translate }}</label>
              <input type="text" id="department" name="department" [(ngModel)]="userData.department"
                [placeholder]="'user_management.form.department_placeholder' | translate" class="form-control">
            </div> -->

            <div class="form-group">
              <label for="position">{{ 'user_management.form.position' | translate }}</label>
              <input type="text" id="position" name="position" [(ngModel)]="userData.position"
                [placeholder]="'user_management.form.position_placeholder' | translate" class="form-control">
            </div>

            <div class="form-group checkbox">
              <label>
                <input type="checkbox" name="enabled" [(ngModel)]="userData.enabled"> {{ 'user_management.form.enabled' | translate }}
              </label>
            </div>
          </div>

          <!-- 權限設定 -->
          <div class="permissions-section">
            <h3>{{ 'user_management.form.permissions_title' | translate }}</h3>
            <div class="form-group" style="margin-bottom: 10px;">
              <label for="permissionType">{{ 'user_management.form.permission_type' | translate }}</label>
              <select id="permissionType" name="permissionType" [(ngModel)]="userData.permissionType"
                class="form-control" (change)="onPermissionTypeChange()">
                <option value="all">{{ 'user_management.form.all_assistants' | translate }}</option>
                <option value="individual">{{ 'user_management.form.individual_assistants' | translate }}</option>
              </select>
            </div>

            <!-- 所有AI助手統一權限設定 -->
            <div *ngIf="userData.permissionType === 'all'" class="all-assistants-section">
              <p>{{ 'user_management.form.all_assistants_description' | translate }}</p>
              <div class="form-group">
                <label>{{ 'user_management.form.permission_level' | translate }}</label>
                <select name="allAssistantsPermission" [(ngModel)]="userData.allAssistantsPermission" class="form-control">
                  <option *ngFor="let role of roleOptions" [value]="role.value">
                    {{ role.label | translate }}
                  </option>
                </select>
              </div>
            </div>

            <!-- 個別AI助手權限設定 -->
            <div *ngIf="userData.permissionType === 'individual'">
              <p>{{ 'user_management.form.individual_assistants_description' | translate }}</p>
              <div *ngFor="let permission of userData.modules; let i = index" class="permission-item">
                <div class="permission-inputs">
                  <div class="form-group">
                    <label>{{ 'user_management.form.ai_assistant' | translate }}</label>
                    <select [(ngModel)]="permission.assistantNo" name="assistantNo_{{i}}" class="form-control">
                      <option value="">{{ 'user_management.form.select_assistant' | translate }}</option>
                      <option *ngFor="let assistant of assistants" [value]="assistant.assistantNo">
                        {{ assistant.title }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>{{ 'user_management.form.permission' | translate }}</label>
                    <select [(ngModel)]="permission.permission" name="permission_{{i}}" class="form-control">
                      <option *ngFor="let role of roleOptions" [value]="role.value">
                        {{ role.label | translate }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="remove-btn-container">
                  <button type="button" class="btn btn-danger" (click)="removePermission(i)">
                    {{ 'user_management.form.remove_permission' | translate }}
                  </button>
                </div>
              </div>

              <button type="button" class="btn btn-outline" (click)="addPermission()">
                {{ 'user_management.form.add_permission' | translate }}
              </button>
            </div>
          </div>

          <!-- 表單按鈕 -->
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" [disabled]="userForm.invalid" (click)="submitUserForm()">
              {{ isEditing ? ('user_management.form.update' | translate) : ('user_management.form.create' | translate) }}
            </button>
            <button type="button" class="btn btn-secondary" (click)="closeUserModal()">{{ 'user_management.form.cancel' | translate }}</button>

            <!-- 顯示表單驗證錯誤訊息，幫助診斷問題 -->
            <!-- <div *ngIf="userForm.invalid" class="form-validation-error">
              <small class="text-danger">{{ 'user_management.form.validation_failed' | translate }}</small>
              <small *ngIf="debugMode">
                <pre>{{ getFormValidationErrors() }}</pre>
              </small>
            </div> -->
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- 組織架構設定彈出視窗 -->
  <div class="org-settings-backdrop" [class.show]="showOrgSettingsModal" (click)="closeOrgSettingsModal()"></div>
  <div class="org-settings-modal" [class.show]="showOrgSettingsModal">
    <div class="org-settings-content" (click)="$event.stopPropagation()">
      <div class="org-settings-header">
        <h2>{{ 'user_management.organization_settings.title' | translate }}</h2>
        <button type="button" class="close-btn" (click)="closeOrgSettingsModal()">&times;</button>
      </div>

      <div class="org-settings-body">
        <div class="org-settings-main">
          <!-- 左側：組織樹 -->
          <div class="org-tree-section">
            <h3>{{ 'user_management.organization_settings.organization_chart' | translate }}</h3>
            <div class="org-tree-actions">
              <button class="btn btn-primary" (click)="addDepartment()">
                <i class="fas fa-plus"></i> {{ 'user_management.organization_settings.add_root_department' | translate }}
              </button>
            </div>

            <div class="org-tree-container">
              <app-organization-management-tree-node
                *ngIf="organizationData"
                [node]="organizationData"
                [parent]="null"
                [siblings]="[organizationData]"
                [nodeIndex]="0"
                [level]="0"
                (moveUp)="onOrgNodeMoveUp($event)"
                (moveDown)="onOrgNodeMoveDown($event)"
                (editNode)="onOrgNodeEdit($event)"
                (addChild)="onOrgNodeAddChild($event)"
                (deleteNode)="onOrgNodeDelete($event)"
                (toggleExpanded)="onOrgNodeToggleExpanded($event)">
              </app-organization-management-tree-node>
            </div>
          </div>

          <!-- 右側：編輯表單 -->
          <div class="org-form-section" *ngIf="orgEditMode">
            <h3>{{ orgEditMode === 'add' ? ('user_management.organization_settings.add_department' | translate) : ('user_management.organization_settings.edit_department' | translate) }}</h3>

            <form class="org-form">
              <div class="form-group">
                <label for="orgName">{{ 'user_management.organization_settings.department_name' | translate }} *</label>
                <input type="text" id="orgName" [(ngModel)]="orgFormData.name"
                       name="orgName" class="form-control" [placeholder]="'user_management.organization_settings.department_name_placeholder' | translate" required>
              </div>

              <div class="form-group" *ngIf="orgEditMode === 'add'">
                <label for="parentDept">{{ 'user_management.organization_settings.parent_department' | translate }}</label>
                <select id="parentDept" [(ngModel)]="orgFormData.parentId"
                        name="parentDept" class="form-control">
                  <option value="">{{ 'user_management.organization_settings.select_parent' | translate }}</option>
                  <option *ngFor="let dept of getDepartmentsWithLevel()" [value]="dept.id">
                    {{ dept.name }}
                  </option>
                </select>
              </div>

              <div class="form-actions">
                <button type="button" class="btn btn-primary" (click)="saveOrgChanges()"
                        [disabled]="!orgFormData.name.trim()">
                  {{ orgEditMode === 'add' ? ('user_management.organization_settings.add' | translate) : ('user_management.organization_settings.save' | translate) }}
                </button>
                <button type="button" class="btn btn-secondary" (click)="resetOrgForm()">
                  {{ 'user_management.organization_settings.cancel' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="org-settings-footer">
        <button type="button" class="btn btn-primary" (click)="closeOrgSettingsModal()">
          {{ 'user_management.organization_settings.complete_settings' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 部門成員管理模態框 -->
<div class="modal" *ngIf="showDepartmentMemberModal" (click)="closeDepartmentMemberModal()">
  <div class="modal-content department-member-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'user_management.department_member.modal_title' | translate }} - {{ selectedDepartment?.name }}</h3>
      <button type="button" class="btn btn-close" (click)="closeDepartmentMemberModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <!-- 用戶選擇下拉選單 -->
      <div class="user-selection-section">
        <h4><i class="fas fa-users"></i> {{ 'user_management.department_member.select_users' | translate }}</h4>

        <!-- 用戶篩選類型選擇 -->
        <div class="user-filter-type-section">
          <h5>{{ 'user_management.department_member.filter_type' | translate }}</h5>
          <div class="radio-group">
            <label class="radio-option">
              <input type="radio"
                     name="userFilterType"
                     value="all"
                     [(ngModel)]="userFilterType"
                     (change)="onUserFilterTypeChange()">
              <span class="radio-label">{{ 'user_management.department_member.show_all_users' | translate }}</span>
            </label>
            <label class="radio-option">
              <input type="radio"
                     name="userFilterType"
                     value="noDepartment"
                     [(ngModel)]="userFilterType"
                     (change)="onUserFilterTypeChange()">
              <span class="radio-label">{{ 'user_management.department_member.show_unassigned_only' | translate }}</span>
            </label>
          </div>
        </div>

        <div class="user-dropdown-container">
          <label for="userDropdown" class="form-label">{{ 'user_management.department_member.select_from_users' | translate }}</label>
          <select id="userDropdown"
                  class="form-select user-dropdown"
                  [(ngModel)]="selectedUserToAdd"
                  (change)="onUserDropdownChange()">
            <option value="">{{ 'user_management.department_member.please_select_user' | translate }}</option>
            <optgroup *ngFor="let group of getGroupedUsers()" [label]="group.label">
              <option *ngFor="let user of group.users"
                      [value]="user.id"
                      [disabled]="isUserInSelectedList(user) || isUserAlreadyInDepartment(user)">
                {{ user.fullName || user.username }} ({{ user.email }})
                <span *ngIf="isUserAlreadyInDepartment(user)"> - {{ 'user_management.department_member.already_in_department' | translate }}</span>
                <span *ngIf="isUserInSelectedList(user)"> - {{ 'user_management.department_member.selected' | translate }}</span>
              </option>
            </optgroup>
          </select>

        </div>
      </div>

      <!-- 已選擇的用戶表格 -->
      <div class="selected-users-section">
        <div class="section-header">

          <button *ngIf="selectedUsersToAdd.length > 0"
                  class="btn btn-sm btn-outline-danger"
                  (click)="clearAllSelectedUsers()"
                  title="清除所有選擇">
            <i class="fas fa-trash"></i>
            {{ 'user_management.department_member.clear_list' | translate }}
          </button>
        </div>

        <!-- 用戶表格 -->
        <div class="selected-users-table-container" *ngIf="selectedUsersToAdd.length > 0">
          <table class="table selected-users-table">
            <thead>
              <tr>
                <th width="50">#</th>
                <th>{{ 'user_management.department_member.table.full_name' | translate }}</th>
                <th>{{ 'user_management.department_member.table.username' | translate }}</th>
                <th>{{ 'user_management.department_member.table.email' | translate }}</th>
                <th>{{ 'user_management.department_member.table.current_department' | translate }}</th>
                <th width="80">{{ 'user_management.table.actions' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of selectedUsersToAdd; let i = index"
                  class="selected-user-row"
                  [attr.data-index]="i">
                <td class="row-number">{{ i + 1 }}</td>
                <td class="user-name-cell">
                  <div class="user-display-name">
                    <i class="fas fa-user user-icon"></i>
                    {{ user.fullName || user.username }}
                  </div>
                </td>
                <td class="username-cell">
                  <span class="username-badge">{{ user.username }}</span>
                </td>
                <td class="email-cell">
                  <span class="email-text">{{ user.email }}</span>
                </td>
                <td class="departments-cell">
                  <div class="department-tags" *ngIf="getUserOrganizationUnits(user).length > 0">
                    <span *ngFor="let dept of getOrganizationUnitTags(user)"
                          class="dept-tag-small">
                      {{ dept }}
                    </span>
                  </div>
                  <span *ngIf="getUserOrganizationUnits(user).length === 0"
                        class="text-muted no-department">
                    {{ 'user_management.department_member.unassigned' | translate }}
                  </span>
                </td>
                <td class="action-cell">
                  <button class="btn btn-sm btn-danger remove-btn"
                          (click)="removeFromSelectedList(i)"
                          title="從列表中移除">
                    <i class="fas fa-times"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 空狀態顯示 -->
        <!-- <div *ngIf="selectedUsersToAdd.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-users"></i>
          </div>
          <p class="empty-text">尚未選擇任何用戶</p>
          <p class="empty-hint">請使用上方搜尋功能來選擇要添加的用戶</p>
        </div> -->
      </div>
    </div>

    <div class="modal-footer">
      <div class="footer-info">
        <small class="text-muted">
          {{ 'user_management.department_member.footer_tip' | translate }}
        </small>
      </div>
      <div class="footer-actions">
        <button type="button" class="btn btn-primary"
                [disabled]="selectedUsersToAdd.length === 0"
                (click)="confirmAddUsersToSelectedDepartment()">
          <i class="fas fa-check"></i> {{ 'user_management.department_member.confirm_add' | translate }} ({{ selectedUsersToAdd.length }})
        </button>
        <button type="button" class="btn btn-secondary" (click)="closeDepartmentMemberModal()">
          {{ 'user_management.department_member.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
